import LZString from 'lz-string';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button, Dialog, Label } from '@revelio/ui';

import { useFilterContext } from '../../../filters/contexts/FilterProvider';
import { buildPathFromPage } from '../../../utils/routing-helpers';
import modalStyles from '../../Modal/themedModal.module.css';
import type { Page } from '../../PageConfigProvider/types';
import { ParameterEntitiesEditor } from './ParameterEntitiesEditor';
import { parametersFromPageConfig } from './parameters';
import styles from './parameters-modal.module.css';

export const EnterParametersModal = ({
  isOpen,
  onClose,
  navigateOnSubmit,
  pageConfig,
}: {
  isOpen: boolean;
  onClose: () => void;
  navigateOnSubmit: boolean;
  pageConfig: Page;
}) => {
  const [canCreateReport, setCanCreateReport] = useState(false);
  const { activeFilterMap } = useFilterContext();
  const navigate = useNavigate();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={pageConfig.name ? `Run ${pageConfig.name}` : 'Run Custom Report'}
      size="2xl"
      className={modalStyles.content}
      footer={
        <Button
          size="sm"
          disabled={!canCreateReport}
          color="primary"
          onClick={() => {
            onClose();
            if (navigateOnSubmit) {
              const entries = Array.from(activeFilterMap.entries());

              const serialized = LZString.compressToEncodedURIComponent(
                JSON.stringify(entries)
              );
              const basePath = buildPathFromPage(pageConfig);
              const to =
                entries.length > 0
                  ? `${basePath}?filters=${serialized}`
                  : basePath;
              navigate(to);
            }
          }}
        >
          Submit
        </Button>
      }
    >
      <Label className={styles.parametersLabel}>Parameters</Label>
      <ParameterEntitiesEditor
        parameters={parametersFromPageConfig(pageConfig)}
        onCanCreateReport={setCanCreateReport}
        showResetCompetitorsButton
      />
    </Dialog>
  );
};
